import React from 'react';
import { COMPARE_PRODUCTS_HEADING, SELECT_PRODUCT_TO_COMPARE } from '../../data/Localization';

export default function InitialBar(props) {
	function handleSelectProd() {
		props.handleSelectProd();
	}

	return (
		<section className="comparison-table">
			<div className="comparison-table__wrapper" aria-selected="false">
				<div className="comparison-table__content">
					<h2 className="comparison-table__content--heading font-size-5 avenir-regular padding-trailer-half">{COMPARE_PRODUCTS_HEADING}</h2>
					<calcite-button onClick={handleSelectProd} scale="l" color="neutral" kind="neutral" icon-end="arrow-right">
						{SELECT_PRODUCT_TO_COMPARE}
					</calcite-button>
				</div>
			</div>
		</section>
	);
}
